import { ICommonButtonProps } from '../../../types/button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';

export const BackButton = ({ onClick }: ICommonButtonProps) => {
  return (
    <IconButton
      onClick={() => {
        onClick();
      }}
    >
      <ArrowBackIcon />
    </IconButton>
  );
};
